// removed by extract-text-webpack-plugin
module.exports = {"icon":"_J4Cp","more":"_1h-NJ","actions":"_1eEWW","actionsTop":"is5pC"};


//////////////////
// WEBPACK FOOTER
// ./app/components/more-button/more-button.scss
// module id = 838
// module chunks = 3 4 5 6 7